import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { LoginMenu } from './LoginMenu/LoginMenu';
import userService from '../user/UserService';
import { Navbar, NavbarBrand } from './NavMenu.styles';
import '../NavMenu.css';
import { AdminMenu } from './AdminMenu';

export function NavMenu ({ setNavMenuIsOpen }) {
  const [isAdministrator, setIsAdministrator] = useState(false);

  useEffect(() => {
    console.log('getting roles');
    userService.userInRole('System Administrator')
      .then(result => setIsAdministrator(result));
  }, []);


  return (
    <header>
      <Navbar>
        <NavbarBrand to="/">NME State Check-In</NavbarBrand>

        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          
          
            {isAdministrator && <AdminMenu />}

            <li>
              <a 
                target="_blank" 
                rel="noopener noreferrer" 
                href="https://sites.google.com/students.fusdaz.org/the-monthly-dose/home"
              >
                NME Resource Website
              </a>
            </li>

            
            
            <LoginMenu setNavMenuIsOpen={setNavMenuIsOpen} />
        </ul>
        
      </Navbar>
    </header>
  );
}
